import React from 'react';
import type { AgentIconProps } from './AgentIconBase';

export default function SubmissionAgent({
  width = '100%',
  height = '100%',
  className = '',
}: AgentIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 150 150"
      width={width}
      height={height}
      className={className}
    >
      <circle fill="#0057a8" cx="75" cy="75" r="75" />
      <polygon
        fill="#fff"
        points="108.57 53.13 87.36 53.17 87.41 32.5 96.33 41.09 108.57 53.13"
      />
      <path
        fill="#fff"
        d="M83.8,58.41c-1.04.11-1.93-.63-1.97-1.67v-24.24s-34.83.06-34.83.06c-3.15,0-5.57,3.12-5.57,6.24v72.39c0,3.42,2.66,6.29,5.95,6.29l54.86.02c3.17,0,6.31-2.34,6.31-6.06l.03-52.99-24.78-.05ZM57.84,48.28h12.83c1.77,0,3.21,1.46,3.21,3.25s-1.44,3.25-3.21,3.25h-12.83c-1.77,0-3.21-1.46-3.21-3.25s1.44-3.25,3.21-3.25ZM57.84,65.75h27.41c1.77,0,3.21,1.46,3.21,3.25s-1.44,3.25-3.21,3.25h-27.41c-1.77,0-3.21-1.46-3.21-3.25s1.44-3.25,3.21-3.25ZM92.16,107.19h-34.33c-1.77,0-3.21-1.46-3.21-3.25s1.44-3.25,3.21-3.25h34.33c1.77,0,3.21,1.46,3.21,3.25s-1.44,3.25-3.21,3.25ZM92.16,89.72h-34.33c-1.77,0-3.21-1.46-3.21-3.25h0c0-1.8,1.44-3.25,3.21-3.25h34.33c1.77,0,3.21,1.46,3.21,3.25s-1.44,3.25-3.21,3.25Z"
      />
    </svg>
  );
}
